import { Chart } from 'primereact/chart'
import './barChart.scss'
import { useEffect, useState } from 'react'

function BarChart({
  data,
  title,
  showLegend = true,
  barThickness,
  containerBorderRadius = 15,
  containerWidth = '100%',
  containerMarginBottom = '20px',
  showHorizontalGridLines = false,
  showVerticalGridLines = false,
  rupeeState = false,
  barSpacing = 0.4,
  barGroupSpacing = 0.3,
}) {
  const [chartOptions, setChartOptions] = useState({})

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 992

      setChartOptions({
        aspectRatio: isMobile ? 1 : 2,
        responsive: true,
        maintainAspectRatio: false, // Allow the chart to resize with the container
        layout: {
          padding: {
            bottom: isMobile ? 5 : 10,
            left: isMobile ? 10 : 20,
            right: isMobile ? 10 : 20,
            top: isMobile ? 20 : 40,
          },
        },
        plugins: {
          customCanvasBackgroundColor: {
            color: 'white',
          },
          title: {
            display: !!title,
            text: title,
            font: {
              size: isMobile ? 12 : 16,
              weight: 'bold',
            },
            position: 'top',
            padding: {
              top: isMobile ? 5 : 10,
              bottom: isMobile ? 15 : 30,
            },
          },
          legend: {
            display: showLegend,
            position: isMobile ? 'top' : 'bottom',
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              padding: isMobile ? 10 : 30,
              color: 'black',
            },
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                let value = context.raw
                if (value >= 1000000) {
                  return `${rupeeState ? '₹ ' : ''}` + (value / 1000000).toFixed(1) + 'M'
                } else if (value >= 1000) {
                  return `${rupeeState ? '₹ ' : ''}` + (value / 1000).toFixed(1) + 'K'
                }
                return value
              },
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              display: showHorizontalGridLines,
            },
            ticks: {
              callback: function (value) {
                if (value >= 1000000) {
                  return `${rupeeState ? '₹ ' : ''}` + (value / 1000000).toFixed(1) + 'M'
                } else if (value >= 1000) {
                  return `${rupeeState ? '₹ ' : ''}` + (value / 1000).toFixed(1) + 'K'
                }
                return value
              },
            },
          },
          x: {
            grid: {
              display: showVerticalGridLines,
            },
            offset: true,
          },
        },
      })
    }

    handleResize() // Set initial options
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [title, showLegend, showHorizontalGridLines, showVerticalGridLines, rupeeState])

  const formattedData = {
    ...data,
    datasets: data.datasets.map((dataset) => ({
      ...dataset,
      barThickness: barThickness,
      categoryPercentage: barGroupSpacing,
      barPercentage: 1 - barSpacing,
    })),
  }

  return (
    <div
      className='barChart-card'
      style={{ width: containerWidth, marginBottom: containerMarginBottom, borderRadius: containerBorderRadius }}
    >
      <Chart type='bar' data={formattedData} options={chartOptions} />
    </div>
  )
}

export default BarChart
